import { render, staticRenderFns } from "./PersonalAccountPassword.vue?vue&type=template&id=6883fcd1&scoped=true&"
import script from "./PersonalAccountPassword.vue?vue&type=script&lang=js&"
export * from "./PersonalAccountPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6883fcd1",
  null
  
)

export default component.exports